"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _globalVariables = require("../../utils/globalVariables");
const useWindowSize = () => {
  const [size, updateSize] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      const checkSize = () => {
        if (window.innerWidth > _globalVariables.windowSizes.tabletLandscape) {
          updateSize("desktop");
        } else if (window.innerWidth > _globalVariables.windowSizes.tabletPortrait) {
          updateSize("tablet");
        } else {
          updateSize("mobile");
        }
      };
      window.addEventListener("resize", checkSize);
      checkSize();
      return () => {
        window.removeEventListener("resize", checkSize);
      };
    }
  }, [_globalVariables.windowSizes]);
  return {
    size
  };
};
var _default = useWindowSize;
exports.default = _default;